(function () {
  'use strict';
  angular.module('obex').
  factory('socketTransmit', ['$rootScope', 'socket', 'socketLogin',
        function ($rootScope, socket, socketLogin) {

          return {
            sendHandleConversation: function (fromNumber) {
              socket.emit('handle conversation', {
                socketId: socketLogin.getSocketId(),
                fromNumber: fromNumber,
              });
            },

            sendStopHandleConversation: function (fromNumber) {
              socket.emit('stop handle conversation', {
                socketId: socketLogin.getSocketId(),
                fromNumber: fromNumber,
              });
            },
          };
        },
    ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/socketTransmit.service.js